// extracted by mini-css-extract-plugin
module.exports = {"container":"w8WuzsFzFGymsVVyF575D","icon":"_1d3GSRuiMqasD-tjYGxFJD"};